import React from "react";
import { FormControl, IconButton } from "@mui/material";
import NoTicketDetail from "../../../FlightPackage/NoTicketDetail";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import { TicketLineItemExtended } from "../../../Utils/TypeExtensions";
import { DUMMY_CHARGE_LINE_ITEM_TYPE } from "../../../sharedCode/metadata";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import DetailPage from "../../../Components/navigation/detailPage";
import ChargeDetails from "../../../Components/ticket/chargeDetails";
import { addLineItem } from "../../../Utils/TicketDatabase";

export function TicketCharges(props: TicketProps): JSX.Element {
    if (!props.ticket) return <NoTicketDetail />;

    return (
        <DetailPage>
            <FormControl fullWidth>
                <ChargeDetails {...props} />
                <Typography>
                    <IconButton disabled={props.isReadOnly} size="large" color="inherit" sx={{ ml: 2, mr: 2, alignItems: "left" }} onClick={handleAdd}>
                        <AddIcon />
                    </IconButton>
                </Typography>
            </FormControl>
        </DetailPage>
    );

    function handleAdd(): void {
        const id = props.ticket.nextLocalId;
        const newLineItem = {
            id,
            comments: "",
            ticket_id: props.ticket.id,
            line_item_type_id: DUMMY_CHARGE_LINE_ITEM_TYPE,
        } as TicketLineItemExtended;

        addLineItem(props.ticket.id, newLineItem).catch(() => props.showForceReloadDialogue());
    }
}
